import React, { useState, useRef } from "react";
import { motion, AnimatePresence } from "framer-motion";
import logo from "../assets/customerSupport.webp";
import "./Hero.css";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
let openBookingPopup;

export const triggerBookingPopup = () => {
  if (openBookingPopup) {
    openBookingPopup(true);
  }
};

const Header = () => {
const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);

  const [showForm, setShowForm] = useState(false);
    openBookingPopup = setShowForm;
  const [errors, setErrors] = useState({});
  const formRef = useRef();
  const [location, setLocation] = useState("");
  const [loadingLocation, setLoadingLocation] = useState(false);
  const [serviceType, setServiceType] = useState("");
  const [brandsOpen, setBrandsOpen] = useState(false);
  const [servicesOpen, setServicesOpen] = useState(false);
  const [mobileBrandsOpen, setMobileBrandsOpen] = useState(false);
  const [mobileServicesOpen, setMobileServicesOpen] = useState(false);

  const brandLinks = [
    { name: "All Brands", to: "/brands" },
    { name: "LG", to: "/lg-appliance-service-bangalore" },
    { name: "Samsung", to: "/samsung-appliance-repair-bangalore" },
    { name: "IFB", to: "/ifb-appliance-repair-bangalore" },
    { name: "Whirlpool", to: "/whirlpool-appliance-repair-bangalore" },
    { name: "Bosch", to: "/bosch-appliance-repair-bangalore" },
  ];

  const serviceLinks = [
    { name: "Washing Machine", to: "/washing-machine-service-bangalore" },
    { name: "Refrigerator", to: "/fridge-service-bangalore" },
    { name: "AC Service", to: "/ac-service-bangalore" },
 
  ];


  /* ================= VALIDATION ================= */
  const validate = (data) => {
    let err = {};

    // ✅ NAME
    if (!data.name || data.name.trim().length < 3) {
      err.name = "Enter valid name (min 3 chars)";
    }

    // ✅ PHONE (clean + validate)
    const phone = data.phone ? data.phone.replace(/\D/g, "") : "";
    if (!/^[6-9]\d{9}$/.test(phone)) {
      err.phone = "Enter valid 10-digit phone";
    }

    // ✅ EMAIL
    const email = String(data.email || "").trim().toLowerCase();
    if (!email || !/^\S+@\S+\.\S+$/.test(email)) {
      err.email = "Enter valid email";
    }

    // ✅ SERVICE TYPE
    if (!data.serviceType) {
      err.serviceType = "Select service";
    }

    // ✅ ISSUE
    if (!data.service) {
      err.service = "Select issue";
    }

    // ✅ BRAND
    if (!data.brand) {
      err.brand = "Select brand";
    }

    // ✅ LOCATION
    if (!data.location || data.location.trim().length < 3) {
      err.location = "Location required";
    }

    // ✅ DESCRIPTION
    if (!data.issue || data.issue.trim().length < 5) {
      err.issue = "Describe issue (min 5 chars)";
    }

    return err;
  };

  /* ================= SUBMIT ================= */
  const handleSubmit = async (e) => {
    e.preventDefault();

    const form = new FormData(e.target);
    const data = Object.fromEntries(form.entries());
    data.email = String(data.email || "").trim().toLowerCase();

    const validationErrors = validate(data);
    setErrors(validationErrors);

    if (Object.keys(validationErrors).length > 0) return;

    try {
      const res = await fetch("https://api.customersupports24x7.in/api/orders", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      });

      const result = await res.json();
      if (!res.ok) {
        alert(result?.error || "Booking failed");
        return;
      }
      const message =
        result?.confirmationEmailSent === false
          ? "Booking saved, but confirmation email was not sent."
          : "Booking saved and confirmation email sent.";
      setShowForm(false);

navigate("/thank-you", {
  state: { trackingId: result.trackingId }
});
      setShowForm(false);
      navigate("/thank-you", { state: { trackingId: result.trackingId } });
    } catch (err) {
      console.error(err);
      alert("Error ❌");
    }
  };

  /* ================= LOCATION ================= */
  const getLocation = () => {
    if (!navigator.geolocation) {
      alert("Location not supported ❌");
      return;
    }

    setLoadingLocation(true);

    navigator.geolocation.getCurrentPosition(
      async (pos) => {
        const lat = pos.coords.latitude;
        const lon = pos.coords.longitude;

        try {
          const res = await fetch(
            `https://nominatim.openstreetmap.org/reverse?format=json&lat=${lat}&lon=${lon}`
          );
          const data = await res.json();
          setLocation(data.display_name);
        } catch {
          setLocation(`${lat}, ${lon}`);
        }

        setLoadingLocation(false);
      },
      () => {
        alert("Permission denied ❌");
        setLoadingLocation(false);
      }
    );
  };

  return (
    <>
      {/* HEADER */}
      <header className="absolute top-5 left-1/2 -translate-x-1/2 w-[90%] z-50">
        <div className="header-bar">
          <Link to="/" className="header-logo">
            <img src={logo} alt="logo" className="header-logo-img" />
          </Link>

          <nav className="header-nav hidden md:flex items-center gap-7">
            <Link to="/" className="nav-link">Home</Link>
            <Link to="/about" className="nav-link">About</Link>
            <Link to="/contact" className="nav-link">Contact</Link>
            <div
              className="nav-dropdown"
              onMouseEnter={() => setServicesOpen(true)}
              onMouseLeave={() => setServicesOpen(false)}
            >
              <div className="flex items-center gap-1">
                <Link
                  to="/services"
                  className="nav-link"
                  onClick={() => setServicesOpen(false)}
                >
                  Services
                </Link>
                <button
                  type="button"
                  className="nav-link nav-dropdown-btn"
                  aria-haspopup="menu"
                  aria-expanded={servicesOpen}
                >
                  ▾
                </button>
              </div>
              {servicesOpen && (
                <div className="brand-dropdown">
                  {serviceLinks.map((service) => (
                    <Link
                      key={service.name}
                      to={service.to}
                      className="brand-dropdown-link"
                      onClick={() => setServicesOpen(false)}
                    >
                      {service.name}
                    </Link>
                  ))}
                </div>
              )}
            </div>
            <div
              className="nav-dropdown"
              onMouseEnter={() => setBrandsOpen(true)}
              onMouseLeave={() => setBrandsOpen(false)}
            >
              <button
                type="button"
                className="nav-link nav-dropdown-btn"
                aria-haspopup="menu"
                aria-expanded={brandsOpen}
              >
                Brands ▾
              </button>
              {brandsOpen && (
                <div className="brand-dropdown">
                  {brandLinks.map((brand) => (
                    <Link
                      key={brand.name}
                      to={brand.to}
                      className="brand-dropdown-link"
                      onClick={() => setBrandsOpen(false)}
                    >
                      {brand.name}
                    </Link>
                  ))}
                </div>
              )}
            </div>
          </nav>

          <div className="header-actions">
            <button onClick={() => setShowForm(true)} className="book-btn">
              Book Now
            </button>
            {!menuOpen && (
              <button
                onClick={() => setMenuOpen(true)}
                className="header-menu-btn"
                aria-label="Open menu"
              >
                ☰
              </button>
            )}
          </div>
        </div>
      </header>

      {/* POPUP */}
      <AnimatePresence>
        {showForm && (
          <motion.div className="fixed inset-0 bg-black/50 z-[9999] flex justify-center items-center overflow-y-auto p-4">
            <motion.div className="popup-box">
<div className="popup-header">
  <h2>Book Your Appliance Service</h2>
<button
  type="button"
  onClick={() => setShowForm(false)}
  className="close-btn"
>
  ✕
</button>
</div>

              <form ref={formRef} onSubmit={handleSubmit} className="flex flex-col gap-3">

                <input name="name" placeholder="Your Name" className="input" />
                {errors.name && <span className="error">{errors.name}</span>}

                <input
                  name="phone"
                  placeholder="Phone Number"
                  className="input"
                  maxLength="10"
                  onInput={(e) => {
                    e.target.value = e.target.value.replace(/\D/g, "");
                  }}
                />
                {errors.phone && <span className="error">{errors.phone}</span>}

                <input type="email" name="email" placeholder="Email" className="input" />
                {errors.email && <span className="error">{errors.email}</span>}

                <select
                  name="serviceType"
                  className="input"
                  onChange={(e) => setServiceType(e.target.value)}
                >
                  <option value="">Select Service</option>
                  <option value="washing">Washing Machine</option>
                  <option value="fridge">Refrigerator</option>
                  <option value="ac">AC</option>
                </select>
                {errors.serviceType && <span className="error">{errors.serviceType}</span>}

                {serviceType === "washing" && (
                  <select name="service" className="input">
                    <option value="">Select Issue</option>
                    <option>Not Spinning</option>
                    <option>Water Leakage</option>
                  </select>
                )}

                {serviceType === "fridge" && (
                  <select name="service" className="input">
                    <option value="">Select Issue</option>
                    <option>Cooling Problem</option>
                  </select>
                )}

                {serviceType === "ac" && (
                  <select name="service" className="input">
                    <option value="">Select Issue</option>
                    <option>Not Cooling</option>
                  </select>
                )}

                {errors.service && <span className="error">{errors.service}</span>}

                <select name="brand" className="input">
                  <option value="">Select Brand</option>
                  <option>LG</option>
                  <option>Samsung</option>
                  <option>IFB</option>
                  <option>Whirlpool</option>
                </select>
                {errors.brand && <span className="error">{errors.brand}</span>}

<input
  name="location"
  placeholder="Location"
  className="input"
  value={location}
  onChange={(e) => setLocation(e.target.value)}
/>

<button
  type="button"
  onClick={getLocation}
  className="location-btn"
>
  {loadingLocation ? "Detecting..." : "📍 Use My Location"}
</button>



                {errors.location && <span className="error">{errors.location}</span>}

                <textarea name="issue" placeholder="Describe Issue" className="input"></textarea>
               {errors.issue && <span className="error">{errors.issue}</span>}
<button type="submit" className="popup-btn">
  Book Now
</button>
              </form>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
      
{menuOpen && (
  <div className="mobile-menu">

    {/* TOP BAR */}
    <div className="mobile-top">

      <img src={logo} alt="logo" className="mobile-logo" />

      <button
        className="mobile-close"
        onClick={() => setMenuOpen(false)}
      >
        ✕
      </button>
    </div>

    {/* ✅ ADD BOOK BUTTON HERE */}
 

    {/* MENU LINKS */}
    <div className="mobile-links">
      <Link to="/" onClick={() => setMenuOpen(false)}>Home</Link>
      <Link to="/about" onClick={() => setMenuOpen(false)}>About</Link>
      <Link to="/contact" onClick={() => setMenuOpen(false)}>Contact</Link>
      <div>
        <div className="flex items-center justify-between gap-3">
          <Link
            to="/services"
            onClick={() => {
              setMenuOpen(false);
              setMobileServicesOpen(false);
            }}
          >
            Services
          </Link>
          <button
            type="button"
            className="mobile-dropdown-btn"
            onClick={() => setMobileServicesOpen((prev) => !prev)}
          >
            ▾
          </button>
        </div>
        {mobileServicesOpen && (
          <div className="mobile-dropdown-menu">
            {serviceLinks.map((service) => (
              <Link
                key={service.name}
                to={service.to}
                onClick={() => {
                  setMenuOpen(false);
                  setMobileServicesOpen(false);
                }}
              >
                {service.name}
              </Link>
            ))}
          </div>
        )}
      </div>
      <button
        type="button"
        className="mobile-dropdown-btn"
        onClick={() => setMobileBrandsOpen((prev) => !prev)}
      >
        Brands ▾
      </button>
      {mobileBrandsOpen && (
        <div className="mobile-dropdown-menu">
          {brandLinks.map((brand) => (
            <Link
              key={brand.name}
              to={brand.to}
              onClick={() => {
                setMenuOpen(false);
                setMobileBrandsOpen(false);
              }}
            >
              {brand.name}
            </Link>
          ))}
        </div>
      )}
      <button
        onClick={() => {
          setShowForm(true);
          setMenuOpen(false);
        }}
        className="mobile-book top-book"
      >
        Book Now
      </button>
    </div>

  </div>
)}
    </>
  );
};

export default Header;



